import {
  Button,
  CircularProgress,
  SxProps,
  Tooltip,
  Typography,
} from "@mui/material";
import { CSSProperties, MouseEvent, ReactNode } from "react";

interface ButtonProps {
  endIcon?: ReactNode;
  startIcon?: ReactNode;
  label: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps;
  isLoading?: boolean;
  disabled?: boolean;
  textStyle?: SxProps;
  LabelStyle?: CSSProperties;
  tooltipTitle?: string;
}

export const ContainedButton: React.FC<ButtonProps> = ({
  endIcon,
  startIcon,
  label,
  onClick,
  sx,
  isLoading,
  LabelStyle,
}) => {
  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={
        isLoading ? <CircularProgress size={20} color="inherit" /> : endIcon
      }
      onClick={onClick}
      sx={{
        bgcolor: "primary.main",
        color: "white",
        boxShadow: "none",
        padding: "16px 24px",
        borderRadius: "12px",
        height: "56px",
        textTransform: "none",
        ":hover": {
          boxShadow: "none",
          backgroundColor: "black",
        },
        ...sx,
      }}
    >
      <Typography
        sx={{ ...LabelStyle }}
        variant="subtitle2"
        fontWeight="600"
        color="white"
        textAlign="center"
      >
        {label}
      </Typography>
    </Button>
  );
};

export const ButtonPrimary: React.FC<ButtonProps> = ({
  endIcon,
  label,
  onClick,
  sx,
  isLoading,
  disabled,
  textStyle,
  LabelStyle,
  tooltipTitle,
}) => {
  return (
    <Tooltip title={tooltipTitle && tooltipTitle}>
      <Button
        disabled={isLoading || disabled}
        variant="contained"
        endIcon={
          isLoading ? (
            <CircularProgress
              size={20}
              sx={{
                color: "black",
                marginRight: "12px",
              }}
            />
          ) : (
            endIcon
          )
        }
        onClick={onClick}
        sx={{
          bgcolor: "primary.main",
          color: "text.primary",
          // padding: "16px 24px",
          borderRadius: "14px",
          boxShadow: "none",
          height: "52px",
          textTransform: "none",
          ":hover": {
            boxShadow: "none",
            backgroundColor: "primary.main",
          },
          ":disabled": {
            boxShadow: "none",
            bgcolor: "primary.main",
          },
          ...sx,
        }}
      >
        <Typography
          sx={{ ...LabelStyle }}
          variant="body1"
          textAlign="center"
          fontWeight={600}
        >
          {!isLoading && label}
        </Typography>
      </Button>
    </Tooltip>
  );
};

export const ButtonSecondary: React.FC<ButtonProps> = ({
  endIcon,
  startIcon,
  label,
  onClick,
  LabelStyle,
  disabled,
  isLoading,
  sx,
}) => {
  return (
    <Button
      // disabled={disabled || false}
      variant="contained"
      startIcon={startIcon}
      // endIcon={endIcon}
      disabled={isLoading || disabled}
      endIcon={
        isLoading ? (
          <CircularProgress
            size={20}
            sx={{
              color: "white",
              marginRight: "12px",
            }}
          />
        ) : (
          endIcon
        )
      }
      onClick={onClick}
      sx={{
        boxShadow: "none",
        bgcolor: "rgba(255, 255, 255, 0.06)",
        color: "white",
        padding: "16px 24px",
        borderRadius: "16px",
        height: "52px",
        border: "1.6px solid #3D3D3D",
        ":hover": {
          boxShadow: "none",
          border: "1.6px solid #3D3D3D",
          bgcolor: "rgba(255, 255, 255, 0.06)",
        },
        textTransform: "none",
        ...sx,
      }}
    >
      <Typography
        sx={{ ...LabelStyle }}
        variant="subtitle1"
        color="text.secondary"
        textAlign="center"
        fontWeight={600}
      >
        {label}
      </Typography>
    </Button>
  );
};
